<div class="popup-container tlms-popup">
    <header>
        <div class="header" style="display:block">{{heading}}</div>
        <button class="close" style="top:-3px" (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
    </header>
    <ng-container>
        <div style="padding: 16px 24px 16px 24px;">
            <div class="col-12" style="width: 100%;">
                <div class="body">
                    <div>
                        <label class="catlabel">T&E Number<span style="color:#ff0000">*</span></label>
                        <input type="text" class="category" [(ngModel)]="te_number" maxlength="9"
                            [disabled]="eventType=='EDIT'" (keypress)="keyPressNumericTE($event)">
                    </div>
                    <div>
                        <label class="catlabel">Container</label>
                        <input type="text" class="category" [(ngModel)]="container">
                    </div>
                    <div>
                        <label class="catlabel">Seal</label>
                        <input type="text" class="category" [(ngModel)]="seal">
                    </div>
                    <div>
                        <label class="catlabel">WayBill:</label>
                        <input type="text" class="category" [(ngModel)]="waybill">
                    </div>
                    <div>
                        <label class="catlabel">Shipment Type<span style="color:#ff0000">*</span></label>
                        <span class="category">
                            <select class="category" [(ngModel)]="shipmentTypeId">
                                <option *ngFor="let shipmentType of shipmentTypeList"
                                    [value]="shipmentType.shipmentTypeId">
                                    {{shipmentType.description}}
                                </option>
                            </select>
                        </span>
                    </div>
                    <div>
                        <label class="catlabel">Comments</label>
                        <input type="text" class="category" [(ngModel)]="comments">
                    </div>
                </div>
                <label *ngIf="errormsg" class="errormsg"> {{errormsg}} </label>
            </div>
        </div>
        <div class="cfooter d-flex justify-content-between align-items-center popup-footer">
            <button (click)="onNoClick()" class="mCancel"> CANCEL
            </button>
            <button class="black-btn" style="display: inline" (click)="saveClick()">
                SAVE
            </button>
        </div>
    </ng-container>
</div>